import SalesOfficeRequestType from './SalesOfficeRequestType'
import Employee from './Employee'
export class SaveSalesOfficeRequestTypesRequest {
    SalesOfficeRequestTypes: SalesOfficeRequestType[] = [];
    SavedByEmployee: Employee;
}

export default SaveSalesOfficeRequestTypesRequest;